;(function(window, document, undefined) {
  'use strict';
var Deferred = (function(){
  Promise.settle = function(promisesArr){
    var reflectedArr = promisesArr.map(function(promise){
      return promise.then(function(successResult){
        return {
          result: successResult,
          status: 'resolved'
        };
      },function(errorResult){
        return {
          result: errorResult,
          status: 'rejected'
        };
      });
    });
    return Promise.all(reflectedArr);
  };
  
  function Deferred(){
    var def = this;
    /**
     * @instance
     * @memberof Flybits.Deferred
     * @member {external:Promise} promise Instance of an ES6 Promise to be fulfilled.
     */
    this.promise = new Promise(function(resolve,reject){
      /**
       * @instance
       * @memberof Flybits.Deferred
       * @member {function} resolve Callback to be invoked when the asychronous task that initiated the promise is successfully completed.
       */
      def.resolve = resolve;
      /**
       * @instance
       * @memberof Flybits.Deferred
       * @member {function} reject Callback to be invoked when the asychronous task that initiated the promise has failed to complete successfully.
       */
      def.reject = reject;
    });

    this.then = this.promise.then.bind(this.promise);
    this.catch = this.promise.catch.bind(this.promise);
  }

  return Deferred;
})();

var Validation = (function(){
  function Validation(){
    this.state = true;
    this.errors = [];

    this.stacktrace = "";

    this.setStackTrace();
  }

  Validation.prototype = {
    addError: function(header,message,detailsObj){
      this.state = false;
      var retObj = {
        header: header,
        message: message
      };
      if(detailsObj){
        retObj.context = detailsObj.context;
        retObj.code = detailsObj.code;
        retObj.serverCode = detailsObj.serverCode;
      }
      this.errors.push(retObj);

      return this;
    },
    firstError: function(){
      if(this.errors.length > 0){
        return this.errors[0];
      }
      return null;
    },
    setStackTrace: function(){
      var flyError = new Error();
      flyError.name = "FlybitsError";
      this.stacktrace = flyError.stack;
      if(this.stacktrace){
        this.stacktrace = this.stacktrace.split('\n').filter(function(str){
          return str.indexOf('Validation') < 0;
        }).join('\n');
      }
      return this;
    }
  };

  Validation.prototype.type = Validation.type = {};
  Validation.prototype.type.MALFORMED = Validation.type.MALFORMED = 1000;
  Validation.prototype.type.INVALIDARG = Validation.type.INVALIDARG = 1001;
  Validation.prototype.type.MISSINGARG = Validation.type.MISSINGARG = 1002;
  Validation.prototype.type.NOTFOUND = Validation.type.NOTFOUND = 1003;
  Validation.prototype.type.CONNECTIONERROR = Validation.type.CONNECTIONERROR = 1004;
  Validation.prototype.type.UNAUTHENTICATED = Validation.type.UNAUTHENTICATED = 1005;
  Validation.prototype.type.RETRIEVALERROR = Validation.type.RETRIEVALERROR = 1006;
  Validation.prototype.type.NOTSUPPORTED = Validation.type.NOTSUPPORTED = 1007;
  Validation.prototype.type.UNEXPECTED = Validation.type.UNEXPECTED = 1008;

  return Validation;
})();

var DemoPlugin = (function(){
  function DemoPlugin(opts){
    Flybits.context.ContextPlugin.call(this,opts);
    this.lastObj = null;
  };

  DemoPlugin.prototype = Object.create(Flybits.context.ContextPlugin.prototype);
  DemoPlugin.prototype.constructor = DemoPlugin;

  DemoPlugin.prototype.TYPEID = DemoPlugin.TYPEID = 'ctx.demo.plugin';

  DemoPlugin.prototype.isSupported = DemoPlugin.isSupported = function(){
    return Promise.resolve();
  };

  DemoPlugin.prototype.getState = DemoPlugin.getState = function(){
    return Promise.resolve(this.lastObj);
  };

  DemoPlugin.prototype.setState =  function(obj){
    this.lastObj = obj;
    return Flybits.context.ContextPlugin.prototype.setState.call(this, obj);
  };

  return DemoPlugin;
})();
var DataPlugin = (function(){
  function DataPlugin(opts){
    Flybits.context.ContextPlugin.call(this,opts);
  }

  DataPlugin.prototype = Object.create(Flybits.context.ContextPlugin.prototype);
  DataPlugin.prototype.constructor = DataPlugin;

  DataPlugin.prototype.TYPEID = DataPlugin.TYPEID = 'ctx.telco.content';

  DataPlugin.prototype.isSupported = DataPlugin.isSupported = function(){
    return Promise.resolve();
  };

  DataPlugin.prototype.getState = DataPlugin.getState = function(){
    return Promise.resolve();
  };

  return DataPlugin;
})();
var CTAPlugin = (function(){
  function CTAPlugin(opts){
    Flybits.context.ContextPlugin.call(this,opts);
  }

  CTAPlugin.prototype = Object.create(Flybits.context.ContextPlugin.prototype);
  CTAPlugin.prototype.constructor = CTAPlugin;

  CTAPlugin.prototype.TYPEID = CTAPlugin.TYPEID = 'ctx.telco.cta';

  CTAPlugin.prototype.isSupported = CTAPlugin.isSupported = function(){
    return Promise.resolve();
  };

  CTAPlugin.prototype.getState = CTAPlugin.getState = function(){
    return Promise.resolve();
  };

  return CTAPlugin;
})();
var DemographicPlugin = (function(){
  function DemographicPlugin(opts){
    DemoPlugin.call(this,opts);
  }

  DemographicPlugin.prototype = Object.create(DemoPlugin.prototype);
  DemographicPlugin.prototype.constructor = DemographicPlugin;

  DemographicPlugin.prototype.TYPEID = DemographicPlugin.TYPEID = 'ctx.telco.demographic';

  return DemographicPlugin;
})();

var UsagePlugin = (function(){
  function UsagePlugin(opts){
    DemoPlugin.call(this,opts);
  }

  UsagePlugin.prototype = Object.create(DemoPlugin.prototype);
  UsagePlugin.prototype.constructor = UsagePlugin;

  UsagePlugin.prototype.TYPEID = UsagePlugin.TYPEID = 'ctx.telco.usage';

  return UsagePlugin;
})();

var TravelPlugin = (function(){
  function TravelPlugin(opts){
    DemoPlugin.call(this,opts);
  }

  TravelPlugin.prototype = Object.create(DemoPlugin.prototype);
  TravelPlugin.prototype.constructor = TravelPlugin;

  TravelPlugin.prototype.TYPEID = TravelPlugin.TYPEID = 'ctx.telco.travelfreq';

  return TravelPlugin;
})();
var BundlePlugin = (function(){
  function BundlePlugin(opts){
    DemoPlugin.call(this,opts);
  }

  BundlePlugin.prototype = Object.create(DemoPlugin.prototype);
  BundlePlugin.prototype.constructor = BundlePlugin;

  BundlePlugin.prototype.TYPEID = BundlePlugin.TYPEID = 'ctx.telco.package';

  return BundlePlugin;
})();
var LoadingView = Vue.extend({
  template:'#view-loading',
});
Vue.component('loading-view',LoadingView);
var LoaderBar = Vue.extend({
  template:'#loader-bar',
});
Vue.component('loader-bar',LoaderBar);

var HeaderBar = Vue.extend({
  template:'#header-bar',
  props: {
    headerTitle: {
      type: String
    },
    backMode: {
      type: Boolean,
      default: false
    },
    showLogo: {
      type: Boolean,
      default: true
    },
    themeColor: {
      type: String,
      default: '#005692'
    },
    fontColor: {
      type: String,
      default: '#000000'
    }
  },
  methods:{
    conAction: function(){
      if(this.backMode){
        App.router.back();
      } else{
        App.evt.emit(App.actions.MAIN_MENU,true);
      }
    }
  },
});
Vue.component('header-bar',HeaderBar);

var SideBar = Vue.extend({
  template:'#side-bar',
  props: ['user', 'opts', 'debug', 'pollEnabled', 'version', 'profile'],
  data: function(){
    return {
      isOpen: false,
      startX: 0,
      startY: 0,
      startScrollY: 0,
      currentX: 0,
      currentY: 0,
      translateX: 0,
      isTouching: false,
      isUserOptsOpen: false
    };
  },
  watch: {
    isOpen: function(newVal,oldVal){
      var view = this;
      if(newVal){
        setTimeout(function(){
          $('html,body').on('click.sidemenu touchstart.sidemenu',function(e){
            var menuShell = $(e.target).closest('.side-bar .contents');
            if(menuShell.length <= 0){
              view.isOpen = false;
            }
          });
        },100);
      } else{
        $('html,body').off('.sidemenu');
        this.$elScroller.scrollTop = 0;
        view.isUserOptsOpen = false;
      }
    }
  },
  methods: {
    appInit: function(){
      var view = this;

      App.evt.on(App.actions.MAIN_MENU,function(bool){
        if(bool){
          view.isOpen = true;
        } else{
          view.isOpen = false;
        }
      });
    },
    clearCIViewed: function(){
      var view = this;
      App.store.prop.viewed.clear().then(function(){
        App.toast.info('view states cleared');
      });

      setTimeout(function(){
        view.isOpen = false;
      },100);
    },
    toggleUserOpts: function(){
      this.isUserOptsOpen = !this.isUserOptsOpen;
    },
    togglePolling: function(){
      if(this.pollEnabled){
        App.stopPoll();
      } else{
        App.startPoll();
      }
    },
    gotoCTX: function(){
      var view = this;
      App.router.push('context');
      setTimeout(function(){
        view.isOpen = false;
      },100);
    },
    changeProfile: function(){
      var view = this;
      App.router.push('seed');
      setTimeout(function(){
        view.isOpen = false;
      },100);
    },
    resetUser: function(){
      App.evt.emit(App.actions.LOADING,true);
      App.clearSession();
      Flybits.Session.disconnect().catch(function(){}).then(function(){
        window.location.reload();
      });
    },
    updatePosition: function(){
      if(!this.isTouching){
        return;
      }
      requestAnimationFrame(this.updatePosition);

      this.translateX = Math.min(0, this.currentX - this.startX);
      this.$elContent.style.transform = "translateX("+this.translateX+"px)";
      this.$elScroller.scrollTop = this.startScrollY - (this.currentY - this.startY);
    },
    touchStart: function(e){
      this.startX = e.pageX || e.touches[0].pageX;
      this.startY = e.pageY || e.touches[0].pageY;
      this.startScrollY = this.$elScroller.scrollTop;
      this.currentX = this.startX;
      this.currentY = this.startY;
      this.isTouching = true;
      this.$elContent.style.transition = "none";

      requestAnimationFrame(this.updatePosition);
    },
    touchMove: function(e){
      this.currentX = e.pageX || e.touches[0].pageX;
      this.currentY = e.pageY || e.touches[0].pageY;
      this.translateX = Math.min(0, this.currentX - this.startX);

      e.preventDefault();
      e.stopPropagation();
      return false;
    },
    touchEnd: function(e){
      this.isTouching = false;
      this.translateX = Math.min(0, this.currentX - this.startX);
      this.$elContent.style.transform = '';
      this.$elContent.style.transition = '';

      var bounds = this.$elContent.getBoundingClientRect();
      if(bounds.left <= bounds.width/-2){
        this.isOpen = false;
      }
    }
  },
  mounted: function(){
    var view = this;
    setTimeout(function(){
      App.ready.then(function(){
        view.appInit();
      });
    },1);
    this.$elContent = $(this.$el).find('.contents')[0];
    this.$elScroller = $(this.$el).find('.scroll-wrap')[0];
    $(this.$elContent).on('touchstart',view.touchStart);
    $(this.$elContent).on('touchmove',view.touchMove);
    $(this.$elContent).on('touchend',view.touchEnd);
  }
});
Vue.component('side-bar',SideBar);

var CardPlaceholder = Vue.extend({
  template:'#card-placeholder',
  data: function(){
    return {
      block: 0
    };
  },
  methods: {
    /** inclusive */
    getRandomInt: function(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    } 
  },
  mounted: function(){
    this.block = this.getRandomInt(0,3);
  }
});
Vue.component('card-placeholder',CardPlaceholder);

var CardBase = Vue.extend({
  template:'#card-base',
  props: {
    content: {
      type: Object
    }
  },
  watch: {
    'content.data': function(){
      this.setData();
    }
  },
  methods: {
    setData: function(){
      
    }
  },
  mounted: function(){
    if(this.content && this.content.data){
      this.setData();
    }
  }
});
Vue.component('card-base',CardBase);

var CardCta = Vue.extend({
  template:'#card-cta',
});
Vue.component('card-cta',CardCta);

var CardText = CardBase.extend({
  template:'#card-text',
  data: function(){
    return {
      root: {
        title: {},
        body: {}
      }
    };
  },
  computed: {
    themeColor: function(){
      return App.vm.currentProfile.color || "#005692";
    }
  },
  methods: {
    setData: function(){
      var view = this;
      this.content.getData().then(function(obj){
        view.root.title = App.util.Obj.toValueObj(obj,'title');
        view.root.body = App.util.Obj.toValueObj(obj,'body'); 
      });
    }
  },
});
Vue.component('card-text',CardText);

var CardVideo = CardBase.extend({
  template:'#card-video',
  data: function(){
    var retObj = {
      videos: []
    };

    return retObj;
  },
  computed: {
    isMultiple: function(){
      return this.proxyVideos.length > 1;
    },
    proxyVideos: function(){
      return this.videos.slice(0, 3);
    }
  },
  methods: {
    drillDown: function(){
      App.router.push('/videos/'+this.content.id);
    },
    setData: function(){
      var view = this;
      this.content.getData().then(function(obj){
        view.videos = obj.video.data;
      });
    },
    videoPlay: function(vid){
      var ctx = {};
      ctx['viewed.'+App.util.Model.resolveTopicParam(this.content)] = true;
      App.ctx.data.setState(ctx);
    }
  },
});
Vue.component('card-video',CardVideo);

var YtVid = Vue.extend({
  template:'#yt-vid',
  props: {
    rawUrl: {
      type: String
    }
  },
  data: function(){
    return {
      playMode: false,
    };
  },
  computed: {
    vId: function(){
      if(this.rawUrl){
        return App.util.Api.parseYoutubeID(this.rawUrl);
      }
      return;
    },
    thumbnailUrl: function(){
      if(this.vId){
        return 'https://img.youtube.com/vi/'+this.vId+'/maxresdefault.jpg';
      }
      return;
    },
    embedUrl: function(){
      if(this.vId){
        return 'https://www.youtube.com/embed/'+this.vId+'?rel=0&autoplay=1';
      }
      return;
    }
  },
  methods: {
    playVideo: function(){
      this.playMode = true;
      this.$emit('play');
    }
  }
});
Vue.component('yt-vid',YtVid);

var CardArticle = CardBase.extend({
  template:'#card-article',
  data: function(){
    var retObj = {
      articles: []
    };

    return retObj;
  },
  computed: {
    isMultiple: function(){
      return this.articles.length > 1;
    },
  },
  methods: {
    toValueObj: function(rootLocaleObj, propKey){
      return App.util.Obj.toValueObj(rootLocaleObj, propKey);
    },
    openArticle: function(url){
      var ctx = {};
      ctx['viewed.'+App.util.Model.resolveTopicParam(this.content)] = true;
      App.ctx.data.setState(ctx);
      window.open(url, '_blank');
    },
    setData: function(){
      var view = this;
      this.content.getData().then(function(obj){
        view.articles = obj.articles.data;
      });
    }
  },
});
Vue.component('card-article',CardArticle);

var CardEvent = CardBase.extend({
  template:'#card-event',
  data: function(){
    return {
      root: {
        title: {},
        location: {},
        address: {},
        description: {},
        registerURL: '',
        bannerURL: '',
        dateISO: '',
      }
    }
  },
  computed: {
    dateStr: function(){
      if(!this.root.dateISO || this.root.dateISO === ''){
        return '';
      }
      var d = new Date(this.root.dateISO);

      return d.getMonthName() + ' ' +
             d.getDate() + ', ' +
             d.getFullYear() + ' - ' +
             App.util.Obj.zero2Pad(d.getHours()) + ':' + 
             App.util.Obj.zero2Pad(d.getMinutes());
    } 
  },
  methods: {
    drillDown: function(){
      var ctx = {};
      ctx['viewed.'+App.util.Model.resolveTopicParam(this.content)] = true;
      App.ctx.data.setState(ctx);
      App.router.push({
        name: 'event',
        params: {id:this.content.id}
      });
    },
    setData: function(){
      var view = this;
      this.content.getData().then(function(obj){
        view.root.title = App.util.Obj.toValueObj(obj,'title');
        view.root.description = App.util.Obj.toValueObj(obj,'description');
        view.root.location = App.util.Obj.toValueObj(obj,'location');
        view.root.address = App.util.Obj.toValueObj(obj,'address');
        view.root.bannerURL = obj.img;
        view.root.registerURL = obj.registerURL;
        view.root.dateISO = obj.date;
      });
    }
  },
});
Vue.component('card-event',CardEvent);

var LocalizedText = (function(){
  var resolveValue = function(localeObj,key){
    var localeKeys = Object.keys(localeObj);
    return localeObj[key] || localeObj['en'] || localeObj[localeKeys[0]];
  };

  return Vue.extend({
    template:'#localized-text',
    props: {
      localeObj: {
        type: Object,
        default: function(){
          return {
            en: ''
          };
        }
      }
    },
    computed: {
      localizedStr: function(){
        return resolveValue(this.localeObj);
      }
    }
  });
})();
Vue.component('localized-text',LocalizedText);

var LoadingCanvas = Vue.extend({
  template:'#loading-canvas',
});
Vue.component('loading-canvas',LoadingCanvas);

var SplashPage = (function(){

  return {
    template: '#splash-page',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        vm.loadStart = new Date().getTime();
      });
    },
    beforeRouteLeave: function(to, from, next){
      var now = new Date().getTime();
      var diff = now - this.loadStart;
      if(diff < 1500){
        setTimeout(function(){
          next();
        },1500-diff);
      } else{
        next();
      }
    },
  };

})();
Vue.component('splash-page',SplashPage);
var SeedPage = (function(){
  return {
    template:'#seed-page',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        vm.profiles = App.cfg.profiles;
      });
    },
    data: function(){
      return {
        profiles: [],
        isLoading: false
      };
    },
    methods: {
      selectProfile: function(profile){
        var view = this;
        this.isLoading = true;
        App.evt.emit(App.actions.VIBRATE,{
          duration:100
        });

        App.ctx.demographic.setState(profile.demographic);
        App.store.prop.ctxPref.set('demographic',profile.demographic);
        
        var usageState = {
          data: profile.usageData,
          minutes: profile.usageMinutes,
          text: profile.usageText
        };
        App.ctx.usage.setState(usageState);
        App.store.prop.ctxPref.set('usage',usageState);

        var travelState = {
          "days-per-year": profile.travelFreq
        };
        App.ctx.travel.setState(travelState);
        App.store.prop.ctxPref.set('travel',travelState);

        App.ctx.bundle.setState(profile.bundles);
        App.store.prop.ctxPref.set('bundle',profile.bundles);

        App.vm.currentProfile = profile;
        setTimeout(function(){
          view.isLoading = false;
          App.router.push('dashboard');
        },1000);
      },
      trueKey: function(map){
        var keys = Object.keys(map);
        return keys.filter(function(key){
          return map[key];
        })[0];
      },
      formatCurrency: function(num, minimumFractionDigits){
        minimumFractionDigits = typeof minimumFractionDigits === 'number' ? minimumFractionDigits:2;
        return Number(num).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: minimumFractionDigits
        });
      }
    }
  };

})();
Vue.component('seed-page',SeedPage);
var Dashboard = (function(){

  return {
    template:'#dashboard',
    props: ['profile'],
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        if(App.vm.sessionUser){
          App.store.getContents().then(function(arr){
            vm.contents = arr;
          });
        }
      });
    },
    data: function(){
      return {
        contents: []
      };
    },
    computed: {
      proxyContents: function(){
        return this.contents.filter(function(c){
          var internalType = App.cfg.templateMap[c.type];
          return internalType && internalType !== 'intro' && internalType !== 'cta';
        });
      },
      profileColor: function(){
        return this.profile?this.profile.color:'#005692';
      },
      fontColor: function(){
        return this.profile?this.profile.fontColor:'#ffffff';
      },
      profileLabel: function(){
        return this.profile?this.profile.label:'';
      }
    },
    methods: {
      resolveCardType: function(content){
        var internalType = App.cfg.templateMap[content.type];
        if(internalType){
          internalType = 'card-'+internalType;
        }

        return internalType;
      },
      formatCurrency: function(num, minimumFractionDigits){
        minimumFractionDigits = typeof minimumFractionDigits === 'number' ? minimumFractionDigits:2;
        return Number(num).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: minimumFractionDigits
        });
      },
      trueKey: function(map){
        var keys = Object.keys(map);
        return keys.filter(function(key){
          return map[key];
        })[0];
      },
    },
    mounted: function(){
      var startX = 0;
      var currentX = 0;
      var isMenuTouching = false;
      var touchStart = function(e){
        startX = e.pageX || e.touches[0].pageX;
        if(startX <= 20){
          isMenuTouching = true;
        }
      };
      var touchMove = function(e){
        currentX = e.pageX || e.touches[0].pageX;
      };
      var touchEnd = function(e){
        if(isMenuTouching && currentX >= 50){
          App.evt.emit(App.actions.MAIN_MENU,true);
        }
        isMenuTouching = false;
      };
      $(this.$el).on('touchstart',touchStart);
      $(this.$el).on('touchmove',touchMove);
      $(this.$el).on('touchend',touchEnd);
    }
  };

})();
Vue.component('dashboard',Dashboard);
var PageCta = (function(){

  return {
    template:'#page-cta',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        if(App.vm.sessionUser){
          App.store.getContent(to.params.id).then(function(content){
            vm.content = content;

            var ctx = {};
            ctx["viewed."+App.util.Model.resolveTopicParam(vm.content)] = true;
            App.ctx.cta.setState(ctx);
          });
        }
      });
    },
    data: function(){
      return {
        root: {
          bannerURL: '',
          title: {},
          body: {},
          ctaBtn: {},
          dismissBtn: {},
          actionURL: ''
        },
        content: {
          data: {}
        }
      };
    },
    computed: {
      themeColor: function(){
        return App.vm.currentProfile.color || "#005692";
      }
    },
    watch: {
      'content.data': function(newVal, oldVal){
        var view = this;
        this.content.getData().then(function(obj){
          view.root.bannerURL = obj.img;
          view.root.title = App.util.Obj.toValueObj(obj,'title'); 
          view.root.body = App.util.Obj.toValueObj(obj,'description'); 
          view.root.ctaBtn = App.util.Obj.toValueObj(obj,'ctaButton'); 
          view.root.dismissBtn = App.util.Obj.toValueObj(obj,'dismissButton'); 
          view.root.actionURL = obj.url;
        });
      }
    },
    methods: {
      dismiss: function(){
        var ctx = {};
        ctx["accept."+this.content.id] = false;
        App.ctx.cta.setState(ctx);

        // App.router.back();
        App.router.push('/dashboard');
      },
      accept: function(){
        if(this.root.actionURL && this.root.actionURL !== ''){
          window.open(this.root.actionURL,'_blank');
        }

        var ctx = {};
        ctx["accept."+App.util.Model.resolveTopicParam(this.content)] = true;
        App.ctx.cta.setState(ctx);
        
        App.router.back();
      },
      dataChanged: function(){
        var view = this;
        App.store.getContent(this.content.id, App.store.CACHEFIRST).then(function(result){
          if(!result){
            if(view.$route.name === 'cta'){
              App.router.back();
            }
            App.evt.off(App.actions.DATACHANGED, view.dataChanged);
          }
        })
      }
    },
    mounted: function(){
      var view = this;
      App.ready.then(function(){
        App.evt.on(App.actions.DATACHANGED,view.dataChanged);
      });
    }
  };

})();
Vue.component('page-cta',PageCta);
var PageEvent = (function(){

  return {
    template:'#page-event',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        if(App.vm.sessionUser){
          App.store.getContent(to.params.id).then(function(content){
            vm.content = content;
          });
        }
      });
    },
    data: function(){
      return {
        root: {
          title: {},
          location: {},
          address: {},
          description: {},
          registerURL: '',
          bannerURL: '',
          dateISO: '',
        },
        content: {
          data: {}
        }
      };
    },
    computed: {
      dateStr: function(){
        if(!this.root.dateISO || this.root.dateISO === ''){
          return '';
        }
        var d = new Date(this.root.dateISO);
  
        return d.getMonthName() + ' ' +
               d.getDate() + ', ' +
               d.getFullYear() + ' - ' +
               App.util.Obj.zero2Pad(d.getHours()) + ':' + 
               App.util.Obj.zero2Pad(d.getMinutes());
      },
      themeColor: function(){
        return App.vm.currentProfile.color || "#005692";
      }
    },
    watch: {
      'content.data': function(newVal, oldVal){
        var view = this;
        this.content.getData().then(function(obj){
          view.root.title = App.util.Obj.toValueObj(obj,'title');
          view.root.description = App.util.Obj.toValueObj(obj,'description');
          view.root.location = App.util.Obj.toValueObj(obj,'location');
          view.root.address = App.util.Obj.toValueObj(obj,'address');
          view.root.bannerURL = obj.img;
          view.root.registerURL = obj.registerURL;
          view.root.dateISO = obj.date;
        });
      }
    },
    methods: {
      gMapDirURL: function(address){
        if(address){
          return 'https://maps.google.com/maps?daddr='+Flybits.util.Api.htmlEncode(address);
        }
        return '';
      },
    }
  };

})();
Vue.component('page-event',PageEvent);
var PageVideo = (function(){

  return {
    template:'#page-video',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        if(App.vm.sessionUser){
          App.store.getContent(to.params.id).then(function(content){
            vm.content = content;
          });
        }
      });
    },
    data: function(){
      return {
        videos: [],
        content: {
          data: {}
        }
      };
    },
    computed: {
      headerTitle: function(){
        return this.content && this.content.locales? this.content.locales.en.name:'';
      }
    },
    watch: {
      'content.data': function(newVal, oldVal){
        var view = this;
        this.content.getData().then(function(obj){
          view.videos = obj.video.data;
        });
      }
    },
    methods: {
      videoPlay: function(vid){
        var ctx = {};
        ctx['viewed.'+App.util.Model.resolveTopicParam(this.content)] = true;
        App.ctx.data.setState(ctx);
      }
    }
  };

})();
Vue.component('page-video',PageVideo);
var FidoDash = (function(){

  return {
    template:'#fido-dash',
    methods: {
      goto: function(){
        App.router.push('seed');
      }
    }
  };

})();
Vue.component('fido-dash',FidoDash);
var App = (function(){
  var deferredReady = new Deferred();
  
  var resolveSeenContentInstances = function(ciArr){
    var def = new Deferred();
    var getPromises = [];
    ciArr.forEach(function(ci){
      getPromises.push(App.store.prop.viewed.get(ci.id));
    });

    Promise.settle(getPromises).then(function(resultArr){
      var seen = [];
      var notSeen = [];
      resultArr.forEach(function(resultObj, index){
        if(resultObj.status === 'resolves' && resultObj.result){
          seen.push(ciArr[index]);
        } else if(resultObj.status === 'resolved' && !resultObj.result){
          notSeen.push(ciArr[index]);
        }
      });

      def.resolve({
        seen: seen,
        notSeen: notSeen
      });
    });

    return def.promise;
  };

  var App = {
    ready: deferredReady.promise,
    vm: null,
    evt: null,
    ext:{
      CONFIG:"res/config.json",
      VERSION: 'version.txt'
    },
    actions:{
      LOADING: "loading",
      CONFIG_UPDATE: "configupdated",
      VIBRATE: 'vibrate',
      MAIN_MENU: 'mainmenutrigger',
      DATACHANGED: 'datachanged'
    },
    ctx: {},
    cfg: {},
    util: {},
    initConfig:function(){
      var app = this;
      var def = new Deferred();

      fetch(this.ext.CONFIG).then(function(resp){
        if(resp.status !== 200){
          throw new Validation().addError("Configuration file not found","Reverting to default configuration. No configuration found at:"+app.ext.CONFIG,{
            code: Flybits.Validation.type.MISSINGARG
          });
        }
        return resp.json();
      }).then(function(json){
        app.cfg = App.util.Obj.extend(app.cfg,json.defaults);
        app.vm.isDebug = app.cfg.debug;
        def.resolve(app.cfg);
      }).catch(function(ex){
        if(ex instanceof Validation){
          def.reject(ex);
        } else{
          def.reject(new Validation().addError("Failed to read configuration file.","Reverting to default configuration. Configuration format incorrect at:"+app.ext.CONFIG,{
            code: Validation.type.MALFORMED
          }));
        }
      });

      return def.promise;
    },
    checkVersion: function(){
      fetch(this.ext.VERSION).then(function(resp){
        return resp.text();
      }).then(function(fileStr){
        App.vm.version = fileStr;
        console.debug(fileStr);
      });
    },
    initSDK: function(){
      var def = new Flybits.Deferred();
      Flybits.init({
        HOST: this.cfg.HOST,
        CTXREPORTDELAY: this.cfg.CTXREPORTDELAY
      }).then(function(){
        def.resolve();
      });

      return def.promise;
    },
    initCTX: function(){
      var def = new Flybits.Deferred();

      Flybits.context.Manager.initialize().then(function(){
        App.ctx.demographic = new DemographicPlugin({
          refreshDelay: 3500
        });
        App.ctx.usage = new UsagePlugin({
          refreshDelay: 3500
        });
        App.ctx.travel = new TravelPlugin({
          refreshDelay: 3500
        });
        App.ctx.bundle = new BundlePlugin({
          refreshDelay: 3500
        });
        App.ctx.data = new DataPlugin({
          refreshDelay: 999999  
        });
        App.ctx.cta = new CTAPlugin({
          refreshDelay: 999999
        });

        return Promise.all([
          Flybits.context.Manager.register(App.ctx.demographic),
          Flybits.context.Manager.register(App.ctx.usage),
          Flybits.context.Manager.register(App.ctx.travel),
          Flybits.context.Manager.register(App.ctx.bundle),
          Flybits.context.Manager.register(App.ctx.data),
          Flybits.context.Manager.register(App.ctx.cta),
        ]);
      }).then(function(){
        def.resolve();
      });

      return def.promise;
    },
    clearSession: function(){
      this.store.flushAll();
      this.vm.sessionUser = null;
    },
    login: function(){
      return Flybits.Session.connect(new Flybits.idp.AnonymousIDP({
        projectID: App.cfg.PROJECTID
      }));
    },
    resolvedRouteName: function(content){
      var type = content?content.type:undefined;
      var routeName = App.cfg.templateMap[type];
      return routeName || 'error';
    },
    goto: function(content,noHistory){
      var routeName = this.resolvedRouteName(content);
      var routeFn = noHistory?'replace':'push';
      App.router[routeFn]({
        name: routeName,
        params:{
          id: content?content.id:''
        }
      });
      if(!routeName){
        App.vm.errorText = 'Unsupported Content';
      }
    },
    evaluateCTA: function(contentArr){
      var curRouteName = App.vm.$route.name;
      if(curRouteName === 'login' || curRouteName === 'intro' || curRouteName === 'cta' || curRouteName === 'splash' || curRouteName === 'seed' || curRouteName === 'fido'){
        return;
      }
      
      var ctas = contentArr.filter(function(content){
        return App.cfg.templateMap[content.type] === 'cta';
      });

      if(ctas.length){
        resolveSeenContentInstances(ctas).then(function(filteredObj){
          if(filteredObj.notSeen.length){
            App.goto(filteredObj.notSeen[0]);
            App.store.prop.viewed.set(filteredObj.notSeen[0].id, true);
            App.evt.emit(App.actions.VIBRATE,{
              pattern: [400,40,400]
            });
          }
        });
      }
    },
    syncTrackedViews: function(contentArr){
      var ids = contentArr.map(function(c){
        return c.id;
      });
      App.store.prop.viewed.sync(ids);
    },
    startPoll: function(){
      this.stopPoll();
      this.vm.pollEnabled = true;
      this.poll();
    },
    stopPoll: function(){
      this.vm.pollEnabled = false;
      clearTimeout(this.pollTimer);
    },
    poll: function(){
      App.store.getContents(App.store.APIFIRST).then(function(result){
        App.evaluateCTA(result);
        App.syncTrackedViews(result);
        var hash = App.util.Model.generateHash(result);
        if(hash !== App.vm.curContentHash){
          App.evt.emit(App.actions.DATACHANGED);
          App.vm.curContentHash = hash;
        }
      }).catch(function(e){
        console.error('> ',e);
      }).then(function(){
        if(App.vm.pollEnabled){
          App.pollTimer = setTimeout(function(){
            App.poll();
          },App.cfg.POLLINTERVAL);
        }
      });
    },
    startup: function(){
      deferredReady.resolve();
      this.initCTX().then(function(){
        return App.store.prop.ctxPref.get('profile');
      }).then(function(profile){
        if(profile){
          App.vm.currentProfile = App.cfg.profiles.filter(function(p){
            return p.id === profile.id;
          })[0];
          App.router.replace('dashboard');
        } else{
          App.router.replace('fido');
        }

        App.startPoll();
      });
    }
  };

  var router = App.router = new VueRouter({
    routes: [{
      path: '/',
      name: 'splash',
      component: SplashPage,
      alias: '/splash'
    },{
      path: '/fido',
      name: 'fido',
      component: FidoDash
    },{
      path: '/seed',
      name: 'seed',
      component: SeedPage
    },{
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },{
      path: '/cta/:id',
      name: 'cta',
      component: PageCta
    },{
      path: '/event/:id',
      name: 'event',
      component: PageEvent
    },{
      path: '/videos/:id',
      name: 'videos',
      component: PageVideo
    }]
  });

  App.vm = new Vue({
    router: router,
    el: '.container',
    data: function(){
      return {
        isLoaded: false,
        isLoading: false,
        isCFGLoaded: false,
        isDebug: false,
        errorText: '',
        sessionUser: null,
        pollEnabled: false,
        currentProfile: null,
        curContentHash: '',
        version: '',
      };
    },
    computed: {
    },
    watch: {
    },
    methods: {
      refreshApp: function(){
        window.location.reload();
      }
    },
    mounted: function(){
      this.isLoaded = true;
      window.App = App;
    },
  });
  
  /**
   * Resusing the Vue event emitter interface but keeping it generic so we can
   * swap it out for our favourite event emitter if we ever need to.
   */
  App.vm.on = App.vm.$on;
  App.vm.off = App.vm.$off;
  App.vm.emit = App.vm.$emit;
  App.evt = App.vm;

  var loaderStack = [];
  var loadStart = 0;
  App.evt.on(App.actions.LOADING,function(bool, noDelay){
    if(bool){
      App.vm.isLoading = true;
      if(loaderStack.length <= 0){
        loadStart = new Date().getTime();
      }
      loaderStack.push(true);
    } else if(!bool && loaderStack.length > 1){
      loaderStack.pop();
    } else if(!bool){
      loaderStack.pop();
      var now = new Date().getTime();
      if(now - loadStart < 300 && !noDelay){
        setTimeout(function(){
          App.vm.isLoading = false;
        },300);
      } else{
        App.vm.isLoading = false;
      }
    }
  });

  App.evt.on(App.actions.VIBRATE, function(opt){
    if('vibrate' in navigator){
      var input = opt? opt.pattern || opt.duration || [200,50,200] : [200,50,200];
      navigator.vibrate(input);
    }
  });

  return App;
})();

/*************************************************/

App.router.replace('/');
App.checkVersion();

App.initConfig().then(function(){
  return App.initSDK();
}).then(function(){
  App.clearSession();
  return App.login();
}).then(function(){
  App.vm.sessionUser = Flybits.Session.user;
  App.startup();
});
App.store = (function(){
  var getModelID = function(model){
    return model.id;
  };

  var ciViewed = new Flybits.store.Record('app.ci.viewed');
  var ctxPref = new Flybits.store.Record('app.ctx');

  var Store = {
    _ciViewed: ciViewed,
    _ctxPref: ctxPref,
    /**
     * returns cache if avaiable otherwise a network request is made
     * and all caches are updated
     */
    CACHEFIRST: 1,
    /**
     * returns cache if available AND still makes a network request to 
     * async update caches after cached result is returned
     */
    APISECOND: 2,
    /**
     * makes network request to update all caches then returns result
     */
    APIFIRST: 3,
    cache: {
      contentStore: {},
      contentDataStore: {}
    },
    prop: {
      viewed: {
        get: function(id){
          return ciViewed.get(id)
        },
        set: function(id,bool){
          if(bool){
            return ciViewed.set(id, true);
          } else{
            return ciViewed.remove(id);
          }
        },
        clear: function(){
          return ciViewed.clear();
        },
        sync: function(sourceOfTruthIDArr){
          ciViewed.keys().then(function(storeIDs){
            for(var i = 0; i < storeIDs.length; i++){
              if(sourceOfTruthIDArr.indexOf(storeIDs[i]) < 0){
                ciViewed.remove(storeIDs[i]);
              }
            } 
          });
        }
      },
      ctxPref: {
        get: function(id){
          return ctxPref.get(id);
        },
        set: function(id, val){
          if(val){
            return ctxPref.set(id, val);
          } else{
            return ctxPref.remove(id);
          }
        },
        clear: function(){
          return ctxPref.clear();
        }
      }
    },
    flushAll: function(){
      this.cache.contentStore = {};
      this.cache.contentDataStore = {};
      ciViewed.clear();
      ctxPref.clear();
    },
    getContents: function(strategy){
      var def = new Deferred();
      strategy = strategy || this.APISECOND;
      var id = 'rc-'+App.vm.sessionUser.id;

      if(strategy === Store.CACHEFIRST || strategy === Store.APISECOND){
        getCached(id).then(function(arr){
          var resolutionPromise = Promise.resolve(arr);
          if(!arr || arr.length < 1 || strategy === Store.APISECOND){
            var networkPromise = getFromNetwork(id);
            if(!arr || arr.length < 1){
              resolutionPromise = networkPromise;
            }
          }
          
          resolutionPromise.then(function(arr){
            def.resolve(arr);
          }).catch(function(e){
            def.reject(e);
          });
        }).catch(function(e){
          def.reject(e);
        });
      } else if(strategy === Store.APIFIRST){
        return getFromNetwork(id);
      }

      return def.promise;
    },
    getContent: function(id){
      return Promise.resolve(this.cache.contentStore[id]) 
    }
  };

  var getFromNetwork = function(id){
    var def = new Flybits.Deferred();
    
    Flybits.api.Content.getAll().then(function(res){
      return updateMemCache(id, res.result);
    }).then(function(modelArr){
      def.resolve(Store.cache.contentStore[id]);
      // return updatePersistentStore(id, storeOpts.store, modelArr);
    }).then(function(){
      // console.log('> done network fetch');
    }).catch(function(e){
      def.reject(e);
    });

    return def.promise;
  };

  var updateMemCache = function(id, modelArr){
    var curArr = Store.cache.contentStore[id];
    if(!curArr){
      curArr = Store.cache.contentStore[id] = [];
    }

    var curIDs = curArr.map(getModelID);
    var serverIDs = modelArr.map(getModelID);

    var toDelete = App.util.Obj.difference(curIDs, serverIDs);
    var toAdd = App.util.Obj.difference(serverIDs, curIDs);
    var toUpdate = App.util.Obj.intersection(curIDs, serverIDs);
    var updateObjMap = {};

    // delete
    toDelete.forEach(function(delID){
      App.util.Obj.removeObject(curArr,undefined,function(obj){
        return obj.id === delID;
      });
      delete Store.cache.contentStore[delID];
    });

    // add
    modelArr.forEach(function(curObj){
      if(toAdd.indexOf(curObj.id) > -1){
        curArr.push(curObj);
        Store.cache.contentStore[curObj.id] = curObj;
      } else if(toUpdate.indexOf(curObj.id) > -1){
        updateObjMap[curObj.id] = curObj;
      }
    });

    // update
    curArr.forEach(function(curObj){
      if(toUpdate.indexOf(curObj.id) > -1){
        curObj.fromJSON(updateObjMap[curObj.id].toJSON());
        curObj.data = updateObjMap[curObj.id].data;
      }
    });

    updateOrder(curArr,serverIDs);

    return Promise.resolve(curArr);
  };

  var updateOrder = function(arr, ids){
    arr.sort(function(a,b){
      var aIndex = ids.indexOf(a.id);
      var bIndex = ids.indexOf(b.id);
      return aIndex - bIndex;
    });
  };

  var getCached = function(id){
    var def = new Deferred();
    var cachedVal = Store.cache.contentStore[id];

    // logic for offline persistence retrieval

    def.resolve(cachedVal);

    return def.promise;
  };

  return Store;
})();
App.util.Obj = (function(){
  var s4 = function(){
    return Math.floor((1 + Math.random()) * 0x10000)
               .toString(16)
               .substring(1);
  };
  
  var Obj = {
    guid:function(tuples){
      var str = 'js';
      if(tuples && tuples > 0){
        for(var i = 0; i < tuples; i++){
          str += str !== 'js'?'-'+s4():s4();
        }
        return str;
      }
      return 'js' + s4() + s4() + '-' + s4() + '-' + s4() + '-' +
           s4() + '-' + s4() + s4() + s4();
    },zero2Pad: function(num){
      return ('0'+num).slice(-2);
    },
    removeObject:function(arr,obj,findCallback){
      var index = arr.indexOf(obj);

      if(findCallback){
        var objs = arr.filter(findCallback);
        if(objs.length > 0){
          index = arr.indexOf(objs[0]);
        }
      }

      if(index >= 0){
        return arr.splice(index,1);
      }
      return arr;
    },
    difference: function(currentSource, sourceOfTruth){
      var diff = [];

      for(var i = 0; i < currentSource.length; i++){
        if(sourceOfTruth.indexOf(currentSource[i]) < 0){
          diff.push(currentSource[i]);
        }
      }
      return diff;
    },
    intersection: function(currentSource, sourceOfTruth){
      var union = [];

      for(var i = 0; i < currentSource.length; i++){
        if(sourceOfTruth.indexOf(currentSource[i]) > -1){
          union.push(currentSource[i]);
        }
      }
      return union;
    },
    toValueObj: function(rootLocaleObj, propKey) {
      var valueObj = {};
      var localeObj = rootLocaleObj.locales || rootLocaleObj.localizations;
      var localeKeys = localeObj?Object.keys(localeObj):[];
      for (var keyIndex = 0; keyIndex < localeKeys.length; keyIndex++) {
        var localeKey = localeKeys[keyIndex];
        var value = localeObj[localeKey][propKey];
        if (value) {
          valueObj[localeKey] = value;
        }
      }
      return valueObj;
    },
    hash: function(str) {
      var hash = 0, i, chr;
      if (str.length === 0) return hash;
      for (i = 0; i < str.length; i++) {
        chr   = str.charCodeAt(i);
        hash  = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
      }
      return 'f'+hash;
    }
  };

  Obj.extend = (function(){
    function isMergeableObject(val) {
      var nonNullObject = val && typeof val === 'object';

      return nonNullObject && Object.prototype.toString.call(val) !== '[object RegExp]' && Object.prototype.toString.call(val) !== '[object Date]';
    }

    function emptyTarget(val) {
      return Array.isArray(val) ? [] : {};
    }

    function cloneIfNecessary(value, optionsArgument) {
      var clone = optionsArgument && optionsArgument.clone === true;
      return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value;
    }

    function defaultArrayMerge(target, source, optionsArgument) {
      var destination = target.slice();
      source.forEach(function (e, i) {
        if (typeof destination[i] === 'undefined') {
          destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
          destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
          destination.push(cloneIfNecessary(e, optionsArgument));
        }
      });
      return destination;
    }

    function mergeObject(target, source, optionsArgument) {
      var destination = {};
      if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
          destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
      }
      Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
          destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
          destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
      });
      return destination;
    }

    function deepmerge(target, source, optionsArgument) {
      var array = Array.isArray(source);
      var options = optionsArgument || { arrayMerge: defaultArrayMerge };
      var arrayMerge = options.arrayMerge || defaultArrayMerge;

      if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument);
      } else {
        return mergeObject(target, source, optionsArgument);
      }
    }

    deepmerge.all = function deepmergeAll(array, optionsArgument) {
      if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements');
      }

      // we are sure there are at least 2 values, so it is safe to have no initial value
      return array.reduce(function (prev, next) {
        return deepmerge(prev, next, optionsArgument);
      });
    };

    return deepmerge;
  })();

  return Obj;
})();
App.util.Api = (function(){
  var defaultAjaxOpts = {
    method: 'GET',
    headers: {}
  };

  var Api = {
    fetch: function(url,opts){
      opts = opts || {};
      opts.respType = opts.respType || 'json';
      var def = new Deferred();
      
      var ajaxOpts = ObjUtil.extend({},defaultAjaxOpts);
      var isJSON = opts.respType === 'json';
      delete opts.respType;
      ObjUtil.extend(ajaxOpts,opts);

      fetch(url,ajaxOpts).then(this.checkResult).then(this.getResultBody)
        .then(function(respObj){
          if(isJSON){
            try{
              respObj.body = api.parseResponse(respObj.body);
              def.resolve(respObj);
            } catch(e){
              def.reject(new Validation().addError("Request Failed","Unexpected server response.",{
                code: Validation.type.MALFORMED,
              }));
            }
          } else{
            def.resolve(respObj);
          }
        }).catch(function(resp){
          api.getResultBody(resp).then(function(resultObj){
            var parsedResp = api.parseErrorMsg(resultObj.body);
            def.reject(new Validation().addError('Request error',parsedResp,{
              serverCode: resp.status
            }));
          });
        });

      return def.promise;
    },
    checkResult: function(resp){
      if(resp.status >= 200 && resp.status < 300){
        return resp;
      }
      throw resp;
    },
    getResultBody: function(resp){
      var def = new Deferred();
      if(resp && resp.text){
        var respHeaders = {};
        resp.headers.forEach(function(val,key){
          respHeaders[key] = val;
        });
        resp.text().then(function(str){
          def.resolve({
            body: str,
            headers: respHeaders
          });
        }).catch(function(e){
          def.reject(e);
        });
      } else{
        def.resolve({
          body: "",
          headers: {}
        });
      }

      return def.promise;
    },
    getResultJSON: function(resp){
      return resp.json();
    },
    htmlEncode:function(value){
      /*global encodeURIComponent*/
      return encodeURIComponent(value);
    },
    htmlDecode:function(str){
      return str.replace(/&#?(\w+);/g, function(match, dec) {
        if(isNaN(dec)) {
          chars = {quot: 34, amp: 38, lt: 60, gt: 62, nbsp: 160, copy: 169, reg: 174, deg: 176, frasl: 47, trade: 8482, euro: 8364, Agrave: 192, Aacute: 193, Acirc: 194, Atilde: 195, Auml: 196, Aring: 197, AElig: 198, Ccedil: 199, Egrave: 200, Eacute: 201, Ecirc: 202, Euml: 203, Igrave: 204, Iacute: 205, Icirc: 206, Iuml: 207, ETH: 208, Ntilde: 209, Ograve: 210, Oacute: 211, Ocirc: 212, Otilde: 213, Ouml: 214, times: 215, Oslash: 216, Ugrave: 217, Uacute: 218, Ucirc: 219, Uuml: 220, Yacute: 221, THORN: 222, szlig: 223, agrave: 224, aacute: 225, acirc: 226, atilde: 227, auml: 228, aring: 229, aelig: 230, ccedil: 231, egrave: 232, eacute: 233, ecirc: 234, euml: 235, igrave: 236, iacute: 237, icirc: 238, iuml: 239, eth: 240, ntilde: 241, ograve: 242, oacute: 243, ocirc: 244, otilde: 245, ouml: 246, divide: 247, oslash: 248, ugrave: 249, uacute: 250, ucirc: 251, uuml: 252, yacute: 253, thorn: 254, yuml: 255, lsquo: 8216, rsquo: 8217, sbquo: 8218, ldquo: 8220, rdquo: 8221, bdquo: 8222, dagger: 8224, Dagger: 8225, permil: 8240, lsaquo: 8249, rsaquo: 8250, spades: 9824, clubs: 9827, hearts: 9829, diams: 9830, oline: 8254, larr: 8592, uarr: 8593, rarr: 8594, darr: 8595, hellip: 133, ndash: 150, mdash: 151, iexcl: 161, cent: 162, pound: 163, curren: 164, yen: 165, brvbar: 166, brkbar: 166, sect: 167, uml: 168, die: 168, ordf: 170, laquo: 171, not: 172, shy: 173, macr: 175, hibar: 175, plusmn: 177, sup2: 178, sup3: 179, acute: 180, micro: 181, para: 182, middot: 183, cedil: 184, sup1: 185, ordm: 186, raquo: 187, frac14: 188, frac12: 189, frac34: 190, iquest: 191, Alpha: 913, alpha: 945, Beta: 914, beta: 946, Gamma: 915, gamma: 947, Delta: 916, delta: 948, Epsilon: 917, epsilon: 949, Zeta: 918, zeta: 950, Eta: 919, eta: 951, Theta: 920, theta: 952, Iota: 921, iota: 953, Kappa: 922, kappa: 954, Lambda: 923, lambda: 955, Mu: 924, mu: 956, Nu: 925, nu: 957, Xi: 926, xi: 958, Omicron: 927, omicron: 959, Pi: 928, pi: 960, Rho: 929, rho: 961, Sigma: 931, sigma: 963, Tau: 932, tau: 964, Upsilon: 933, upsilon: 965, Phi: 934, phi: 966, Chi: 935, chi: 967, Psi: 936, psi: 968, Omega: 937, omega: 969}
          if (chars[dec] !== undefined){
            dec = chars[dec];
          }
        }
        return String.fromCharCode(dec);
      });
    },
    base64Decode: function(str){
      return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    },
    parseResponse: function(rawResponse){
      return JSON.parse(rawResponse,function(key,val){
        if(typeof val === "string"){
          return api.htmlDecode(val);
        }
        return val;
      });
    },
    parseErrorMsg: function(rawResponse){
      try{
        var resp = this.parseResponse(rawResponse);
      } catch(e){
        return "Malformed server response";
      }
      var msg = null;

      if(resp){
        if(resp.error){
          resp = resp.error;
        }
        
        return resp.messageJSON || resp.exceptionMessage || resp.message || "Unexpected error has occurred";
      }

      return msg;
    },
    parseYoutubeID: function(url){
      url = url.split(/(vi\/|v%3D|v=|\/v\/|youtu\.be\/|\/embed\/)/);
      return undefined !== url[2]?url[2].split(/[^0-9a-z_\-]/i)[0]:url[0];
    }
  };

  return Api;
})();
App.util.Model = (function(){
  var Model = {
    resolveTopicParam: function(content){
      if(content.labels && content.labels.length){
        return content.labels[0];
      }

      return content.id;
    },
    generateHash: function(contentArr){
      var ids = contentArr.map(function(c){
        return c.id;
      });
      return App.util.Obj.hash(ids.join(','));
    }
  };

  return Model;
})();
App.util.Browser = (function(){
  Date.prototype.monthNames = [
    "January", "February", "March",
    "April", "May", "June",
    "July", "August", "September",
    "October", "November", "December"
  ];
  Date.prototype.dayNames = [
    "Sunday", "Monday", "Tuesday",
    "Wednesday", "Thursday", "Friday", "Saturday"
  ];
  Date.prototype.getMonthName = function() {
    return this.monthNames[this.getMonth()];
  };
  Date.prototype.getShortMonthName = function () {
    return this.getMonthName().substr(0, 3);
  };
  Date.prototype.getDayName = function(){
    return this.dayNames[this.getDay()];
  };
  Date.prototype.getShortDayName = function(){
    return this.getDayName().substr(0,3);
  };
  
  return {
    getCookie: function(key) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + key + "=");
      if (parts.length == 2) {
        return parts.pop().split(";").shift();
      } else{
        return null;
      }
    },
    setCookie: function(key,value,expiryDateObj){
      var expires = "";
      if (expiryDateObj) {
        expires = "; expires=" + expiryDateObj.toGMTString();
      }
      document.cookie = key + "=" + value + expires + "; path=/";
    },
    getURLParam:function(name) {
      name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS);
      var results = regex.exec(window.location.href);
      if (results === null)
        return "";
      else
        return results[1];
    }
  };
})();
})(window, document);